/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import { HttpClient } from "./http-client";
export class Api extends HttpClient {
    /**
     * No description
     *
     * @name GetConfig
     * @summary Get config by tenant id
     * @request GET:/api/config/{tenant}
     */
    getConfig = ({ tenant }, params = {}) => this.request({
        path: `/api/config/${tenant}`,
        method: "GET",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name GetClientAreaSettings
     * @summary Get settings of Client Area by domain from Origin
     * @request GET:/api/client-area/settings
     */
    getClientAreaSettings = (params = {}) => this.request({
        path: `/api/client-area/settings`,
        method: "GET",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @name GetClientAreaSettingsByTenant
     * @summary Get settings of Client Area by tenant
     * @request GET:/api/client-area/{tenant}
     */
    getClientAreaSettingsByTenant = ({ tenant }, params = {}) => this.request({
        path: `/api/client-area/${tenant}`,
        method: "GET",
        format: "json",
        ...params,
    });
}
//# sourceMappingURL=Api.js.map